import React, { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "../../lib/utils";

interface WebsiteSectionCardProps {
  title: string;
  icon: LucideIcon;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  actions?: React.ReactNode;
}

const WebsiteSectionCard: React.FC<WebsiteSectionCardProps> = ({
  title,
  icon: Icon,
  children,
  className,
  headerClassName,
  bodyClassName,
  actions,
}) => {
  return (
    <div className={cn(
      "bg-white rounded-lg lg:rounded-xl shadow-sm border border-gray-200 overflow-hidden relative",
      className
    )}>
      {/* Card Header */}
      <div className={cn("bg-[#885ABB] px-4 py-3 lg:px-6 lg:py-4 flex items-center justify-between gap-4", headerClassName)}>
        <h3 className="text-sm lg:text-base font-medium text-white flex items-center gap-2 min-w-0">
          {Icon && <Icon size={16} className="text-white lg:w-[18px] lg:h-[18px] shrink-0" />}
          <span className="truncate">{title}</span>
        </h3>
        {actions && (
          <div className="flex-shrink-0">
            {actions}
          </div>
        )}
      </div>

      {/* Card Body */}
      <div className={cn("p-4 lg:p-8", bodyClassName)}>
        {children}
      </div>
    </div>
  );
};

export default WebsiteSectionCard;
